exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.scroll-search[data-v-7797e7b6] {\n  max-height: calc(100vh - 70px);\n  overflow: auto;\n}", "", {"version":3,"sources":["/var/www/vhosts/dev.orderingsimple.com/resources/js/components/shared/searchmenu.vue"],"names":[],"mappings":";AAAA;EACE,+BAA+B;EAC/B,eAAe;CAChB","file":"searchmenu.vue","sourcesContent":[".scroll-search {\n  max-height: calc(100vh - 70px);\n  overflow: auto;\n}"],"sourceRoot":""}]);

// exports
